const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Group Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "agentName_contains",
      label: "Agent Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      label: "Not in use",
      filterValue: { not_in_use_eq: false },
    },
    defaultValue: { not_in_use_eq: false },
    defaultLabel: false,
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/agents/agent-groups-filters.js